import { useEffect } from "react";
import { useAuthImage } from "../context/AuthImageContext";

/**
 * Hook to set the auth layout background image based on current step or page
 * @param imageSrc - The image source to display in the split layout
 */
export const useAuthStepImage = (imageSrc: string | undefined) => {
  const { setImageSrc } = useAuthImage();

  useEffect(() => {
    setImageSrc(imageSrc);
  }, [imageSrc, setImageSrc]);
};
